<!--begin::Container-->
<div
  [ngClass]="headerContainerCSSClasses"
  class="d-flex align-items-stretch justify-content-between"
  >
  @if (loader$ | async; as _loader) {
    <ngb-progressbar
      class="loading-bar"
      height="3px"
      [value]="_loader"
    ></ngb-progressbar>
  }
  <div></div>
  <sc-topbar class="topbar"></sc-topbar>
</div>
